import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, IManagedNote, INoteProps } from 'core/components';
import { Color, Variant } from 'theme/enums';

import { ManageNotes } from './ManageNotes';

interface IProps {
  notes: IManagedNote[];
  isOpenExternal?: boolean;
  updateIsOpenExternal?: (isOpen: boolean) => void;
  addButton?: JSX.Element;
  noteProps?: INoteProps;
  level?: number;
}

export const ManageNotesButton = ({
  notes,
  isOpenExternal = false,
  updateIsOpenExternal = null,
  addButton = null,
  noteProps = {},
  level = 0,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpenExternal) {
      setIsOpen(true);
    }
  }, [isOpenExternal]);

  const { t } = useTranslation();

  const handleOnClose = () => {
    setIsOpen(false);
    updateIsOpenExternal && updateIsOpenExternal(false);
  };

  return (
    <>
      <Button
        text={t('buttonLabelManageNotes')}
        color={Color.PRIMARY}
        variant={Variant.PLAIN}
        onClick={() => setIsOpen(true)}
      />

      <ManageNotes
        level={level}
        isOpen={isOpen}
        onClose={handleOnClose}
        notes={notes}
        addButton={addButton}
        noteProps={noteProps}
      />
    </>
  );
};
